export default __webpack_public_path__ + "static/media/SPF_2036.5193809f.jpg";